export default "__VITE_ASSET__DX1R884M__"